'use strict';

Handlebars.registerHelper('tcLink', function (languageCode) {

    return ('/tc/' + languageCode + '.html');
});


// WEBPACK FOOTER //
// ./shared/helper/tcLink.js